


const openModalCarousel = (item) => {
  const modalCarousel = document.getElementById("omega-modal-carousel");
  const classOpenModal = "omega-modal-carousel-open";
  modalCarousel.innerHTML = `
    <div class="omega-modal-carousel-content">
      <span class="omega-modal-carousel-close" id="omega-modal-carousel-close">&times;</span>
      <div class="omega-modal-carousel-content-image">
        ${item?.media?.type === "VIDEO"
      ? `<div class="carousel-video-container">
                <video 
                  class="carousel-media-video"
                  src="${item.media?.media_url}"
                  autoplay
                  loop
                  playsinline
                ></video>
                <button class="carousel-sound-toggle" aria-label="Toggle sound">
                  <svg class="carousel-sound-icon" viewBox="0 0 24 24" width="24" height="24">
                    <path class="carousel-sound-on" d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                    <path class="carousel-sound-off" d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" style="display: none;"/>
                  </svg>
                </button>
              </div>`
      : `<img src="${item.media?.media_url}" alt="${item.title}">`
    }
      </div>
    </div>
  `;

  document.body.appendChild(modalCarousel);
  modalCarousel.style.display = "flex";
  document.body.classList.add(classOpenModal);

  // Add close button event listener
  const closeButton = modalCarousel.querySelector(
    "#omega-modal-carousel-close",
  );
  closeButton.addEventListener("click", () => {
    const video = modalCarousel.querySelector("video");
    if (video) {
      video.pause();
      video.muted = true;
    }
    modalCarousel.style.display = "none";
    document.body.classList.remove(classOpenModal);
  });

  // Close modal when clicking outside
  modalCarousel.addEventListener("click", (event) => {
    if (event.target === modalCarousel) {
      const video = modalCarousel.querySelector("video");
      if (video) {
        video.pause();
        video.muted = true;
      }
      modalCarousel.style.display = "none";
      document.body.classList.remove(classOpenModal);
    }
  });
};

const getDataMedia = (blockId) => {
  let result = [];
  window?.[`omega_keys_array_carousel_${blockId}`]?.forEach((key) => {
    const keyString = key.toString();
    const dataMedia = window[`omega_medias_carousel_${keyString}`];
    result.push(dataMedia);
  });
  return result;
};

const getVisibleItemsCount = () => {
  const width = window.innerWidth;
  if (width <= 768) return 2; // Mobile: 2 items
  if (width <= 1024) return 3; // Tablet: 3 items
  return 4; // Desktop: 4 items
};

const handleRenderCarousel = () => {
  const carouselContainers = document.querySelectorAll(".omega-carousel-container");
  carouselContainers.forEach((carouselContainer) => {
    const blockId = carouselContainer.dataset.blockId;
    const dataMedias = getDataMedia(blockId);
    let allCarousels = '';

    dataMedias?.forEach((dataMedia, mediaIndex) => {
      let listMedia = dataMedia?.medias ?? [];
      const visibleItems = getVisibleItemsCount();

      let renderListMedia = `
        <div class="omega-carousel-title">
          ${dataMedia?.title || ""}
        </div>
        <div class="omega-carousel-list carousel-${mediaIndex}">
          ${listMedia.length > visibleItems ? '<button class="omega-carousel-prev">‹</button>' : ""}
          <div class="omega-carousel">
            ${listMedia?.sort((a, b) => a.position - b.position)
          ?.map(
            (item, index) => `
              <div class="omega-carousel-item" onclick='openModalCarousel(${JSON.stringify(item)})' key="${index}">
                <div class="omega-carousel-wrapper">
                  ${item.media.type === "VIDEO"
                ? `
                    <img
                      class="omega-carousel-img"
                      src="${item.media.thumbnail_url}"
                      alt="${item.media.title}"
                      crossorigin="anonymous"
                    />
                    <div class="omega-carousel-play-button">▶</div>
                  `
                : `
                    <img
                      src="${item.media.media_url}"
                      alt="${item.media.title}"
                      class="omega-carousel-img"
                      crossorigin="anonymous"
                    />
                  `
            }
                </div>
              </div>
            `,
          )
          .join("")}
          </div>
          ${listMedia.length > visibleItems ? '<button class="omega-carousel-next">›</button>' : ""}
        </div>
      `;

      if (listMedia?.length > 0) {
        allCarousels += renderListMedia;
      }
    });

    if (allCarousels) {
      carouselContainer.innerHTML = allCarousels;
    }
    
    // Add carousel navigation
    dataMedias.forEach((dataMedia, mediaIndex) => {
      let listMedia = dataMedia?.medias ?? [];
      const visibleItems = getVisibleItemsCount();
      
      if (listMedia.length > visibleItems) {
        const carouselWrapper = carouselContainer.querySelector(`.carousel-${mediaIndex}`);
        const carousel = carouselWrapper.querySelector(".omega-carousel");
        const prevButton = carouselWrapper.querySelector(".omega-carousel-prev");
        const nextButton = carouselWrapper.querySelector(".omega-carousel-next");
        let currentPosition = 0;
        const itemWidth =
          carousel.querySelector(".omega-carousel-item").offsetWidth + 12; // Width + margin

        const updateCarousel = () => {
          carousel.style.transform = `translateX(${currentPosition}px)`;
        };

        prevButton.addEventListener("click", () => {
          if (currentPosition < 0) {
            currentPosition += itemWidth;
            updateCarousel();
          }
        });

        nextButton.addEventListener("click", () => {
          const maxPosition = -(itemWidth * (listMedia.length - visibleItems));
          if (currentPosition > maxPosition) {
            currentPosition -= itemWidth;
            updateCarousel();
          }
        });

        // Add resize event listener to update carousel on screen size change
        window.addEventListener("resize", () => {
          const newVisibleItems = getVisibleItemsCount();
          if (newVisibleItems !== visibleItems) {
            handleRenderCarousel();
          }
        });
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    if (e.target.closest(".carousel-sound-toggle")) {
      const video = e.target
        .closest(".carousel-video-container")
        .querySelector("video");
      const soundIcon = e.target
        .closest(".carousel-sound-toggle")
        .querySelector(".carousel-sound-icon");
      const soundOn = soundIcon.querySelector(".carousel-sound-on");
      const soundOff = soundIcon.querySelector(".carousel-sound-off");

      if (video.muted) {
        video.muted = false;
        soundOn.style.display = "block";
        soundOff.style.display = "none";
      } else {
        video.muted = true;
        soundOn.style.display = "none";
        soundOff.style.display = "block";
      }
    }
  });
});

handleRenderCarousel();
